import type { CustomAgentRunStatus } from '@axilon-apps/domains-ontology-ui-state'

import type { Status } from '../../components/primitives/types'
import { runStateToStatus } from '../../lib/run-state-status'

export interface RunStatusView {
  tone: Status
  label: string
}

const RUN_STATUS_LABEL: Record<CustomAgentRunStatus, string> = {
  completed: 'Completed',
  running: 'Running',
  failed: 'Failed',
  cancelled: 'Cancelled',
  pending_dispatch: 'Queued'
}

/** Map a run state to the shared pill tone and an operator-facing label. */
export function runStatusView(state: string): RunStatusView {
  return {
    tone: runStateToStatus(state),
    label: RUN_STATUS_LABEL[state as CustomAgentRunStatus] ?? 'Unknown'
  }
}

export function isLiveRunState(state: string): boolean {
  return state === 'running' || state === 'pending_dispatch'
}
